import { DataBean } from "../DataBean";

export class ProjectDataConsolidated extends DataBean {



    public async exportProjectDataConsolidated(tableName: any, documentsTable: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportProjectDataConsolidated_String_String", [tableName, documentsTable]);
    }

}